import { type FC } from 'react';
import { Form } from 'formik';
import {
  UiStack,
  UiText,
  UiDrawer,
  UiDrawerOverlay,
  UiDrawerContent,
  UiDrawerFooter,
  UiDrawerBody,
  UiButton,
  UiDrawerCloseButton,
  type UiDrawerProps
} from '@/lib/ui';

export interface DrawerProps extends UiDrawerProps {
  title: string
  size?: UiDrawerProps['size']
  isHiddenButton?: boolean
  isLoading?: boolean
  buttonText?: string
  buttonLoadingText?: string
}

const Drawer: FC<DrawerProps> = ({
  title,
  children,
  size = '2xl',
  isHiddenButton = false,
  isLoading = false,
  buttonText = 'Save',
  buttonLoadingText = 'Saving...',
  ...props
}) => {
  return (
    <UiDrawer placement={'right'} size={size} {...props}>
      <Form
        style={{
          display: 'flex'
        }}
      >
        <UiDrawerOverlay />
        <UiDrawerContent bgColor={'gray.100'}>
          <UiDrawerCloseButton size={'lg'} color={'primary.500'} />
          <UiDrawerBody p={0}>
            <UiStack alignItems={'stretch'} p={8}>
              <UiText variant={'h6'} pb={4}>{title}</UiText>
              {children}
            </UiStack>
          </UiDrawerBody>
          <UiDrawerFooter p={0} hidden={isHiddenButton}>
            <UiStack flexDirection={'row-reverse'} p={8}>
              {isLoading
                ? (
                  <UiButton px={8} size={'lg'} shadow={'base'} colorScheme={'gray'}>
                    {buttonLoadingText}
                  </UiButton>
                )
                : (
                  <UiButton px={8} size={'lg'} shadow={'base'} colorScheme={'primary'} type={'submit'}>
                    {buttonText}
                  </UiButton>
                )}
            </UiStack>
          </UiDrawerFooter>
        </UiDrawerContent>
      </Form>
    </UiDrawer>
  );
};

export default Drawer;
